import React, {useEffect} from "react";
import { IAdServer, ITagMetrics } from "@leap4/entities-discrepancy-common";
import {DataPointCard} from "./dataPointCard";
import {Grid, Typography, Skeleton} from "@leap4/frontend";

export interface IDataPointCards {
    dataPoints: Array<{_id:string,name:string,totals:ITagMetrics,adServer:IAdServer, compareData: ITagMetrics}>,
    isLoading:boolean
}

export const DataPointCards = ({dataPoints,isLoading}: IDataPointCards): JSX.Element => {
    return (
        <>
            <Grid container justifyContent={"center"} direction={"column"} style={{marginTop: '15px'}}>
                <Grid item>
                    <Typography variant={"h5"}>Data Points</Typography>
                </Grid>

            </Grid>
            <Grid container justifyContent={"center"} width={"100%"} margin={"5px auto"} spacing={2}>


            {
                !isLoading? dataPoints.map(datapoint => {

                    return (
                        <Grid item key={datapoint._id}>
                            <DataPointCard dataPoint={datapoint} />
                        </Grid>
                    )
                }):[1,2].map(s=> <Skeleton key={s} sx={{borderRadius: "16px", m:"10px"}} variant={"rounded"} height={"300px"} width={"450px"} animation={"wave"}/>)
            }
            </Grid>


        </>
    )


}